'use strict';

var _ = require('underscore'),
    React = require('react'),
    update = require('react/lib/update'),
    Tag = require('../atoms/Tag'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

require('./TagInput.less');

var TagInput = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    value: React.PropTypes.object.isRequired,
    onChange: React.PropTypes.func.isRequired,
    placeholder: React.PropTypes.string
  },

  focus: function () {
    this.refs.input.getDOMNode().focus();
  },

  render: function () {
    var tags = this.props.value.tags,
        text = this.props.value.text;

    return (
      <div className='TagInput'>
        {tags.length > 0 ?
          _.map(tags, this.renderTag) :
          <input ref='input'
                 className={this.props.className}
                 readOnly={this.props.readOnly}
                 placeholder={this.props.placeholder}
                 value={text}
                 onChange={this.handleChange}
                 onFocus={this.props.onFocus}
                 onBlur={this.props.onBlur}
                 onKeyUp={this.props.onKeyUp} />
        }
      </div>
    );
  },

  renderTag: function (tag, index) {
    return (
      <Tag key={index}
           content={tag.content}
           icon={tag.icon}
           onRemove={this.handleRemoveTag.bind(this, index)} />
    );
  },

  handleChange: function (e) {
    this.requestChange({
      text: {
        $set: e.target.value
      }
    });
  },

  handleRemoveTag: function (index) {
    this.requestChange({
      tags: {
        $splice: [[index, 1]]
      }
    });
  },

  requestChange: function (valueUpdate) {
    this.props.onChange(
      update(this.props.value, valueUpdate)
    );
  }
});

module.exports = TagInput;


/** WEBPACK FOOTER **
 ** ./molecules/TagInput.jsx
 **/